<template>
    <div>
        <a href="#main-content" class="sr-only focus:not-sr-only bg-[#365491] text-white p-2 absolute z-50">Skip to main content</a>
        <div class="min-h-screen bg-gray-100">
            <DefaultHeader />
            <div class="flex relative">
                <DefaultSidebar />
                <main id="main-content" tabindex="-1" class="w-full w-custom1 focus:outline-none">
                    <slot></slot>
                </main>
            </div>
            <DefaultFooter />


        </div>
    </div>
</template>

<script>
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
import DefaultHeader from '@/Pages/Partials/Header'
import DefaultSidebar from '@/Pages/Partials/Sidebar'
import DefaultFooter from '@/Pages/Partials/Footer'

export default {
    components: {
        JetApplicationMark,
        JetBanner,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,

        DefaultHeader,
        DefaultSidebar,
        DefaultFooter
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    },
    mounted() {
        if (this.$page.props.is_production) {
            const style = document.createElement('style');
            style.innerHTML = `.is_hide_production { display: none !important; }`;
            document.head.appendChild(style);
        }
    },

    methods: {
        switchToTeam(team) {
            this.$inertia.put(route('current-team.update'), {
                'team_id': team.id
            }, {
                preserveState: false
            })
        },

        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>
<style >
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';
@import 'https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;0,900;1,400&display=swap';

body {
    font-family: 'Lato', sans-serif !important;
}

.heading-color {
    color: #213665;
}

.searching-background-color {
    background-color: #38558e;
}

.button-color {
    background-color: #f7a53a;
}

@media (min-width: 1024px) {
    .w-custom1 {
        width: calc(100% - 275px) 
    }
}

.tooltip .tooltip-top.top {
    top: -30px;
    left: -125px;
}
</style>